import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Global scroll handler for React Router navigation.
 *
 * Behaviour:
 *  - On any route change, smooth-scroll to the top of the page.
 *  - EXCEPTION: if the destination URL contains a hash (e.g. /#genese),
 *    we let the in-page anchor handler scroll to that specific section
 *    instead — this preserves the "Genèse" navbar deep-link behaviour.
 *
 * The "smooth" behaviour can fall back to instant on browsers that do not
 * support smooth scrolling (very rare in 2026).
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // hashed nav (e.g. /#genese) — anchor handler scrolls there
    // Defer to next frame so the new route has time to mount before scroll
    requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } catch {
        window.scrollTo(0, 0);
      }
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
